import { managedKnowledgeRefSchema } from "@redotech/shopper-agent-knowledge-common/managed-knowledge-view";
import { merchantKnowledgeAvailabilitySchema } from "@redotech/shopper-agent-knowledge-common/merchant-knowledge-view";
import * as z from "zod";

/**
 * Enable, disable, draft, or schedule any mix of corpora in one call.
 * Cannot disturb an entry's text — availability lives on the registry.
 */
export const setKnowledgeAvailability = {
  name: "setKnowledgeAvailability" as const,
  input: z
    .object({
      refs: z.array(managedKnowledgeRefSchema),
      availability: merchantKnowledgeAvailabilitySchema,
    })
    .strict(),
  output: z.object({
    /** Refs that were missing or removed count as not updated. */
    updatedCount: z.number(),
  }),
};
